var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"mediacontact-edit","toptitle":"Medienkontakt bearbeiten","title":_vm.title,"subtitle":_vm.subtitle,"width":1200}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('mediacontact-form',{attrs:{"mediacontact":_vm.mediacontact,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }